import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/ui/casoBorde';

// ------- SAGA ------ //

function casoBordeEstado(state) {
  state.casoBordeEstado = true;
}


// function changeStatusLoaderValidar(state, action) {
//   const { isLoading } = action.payload;
//   state.loaderValidar = isLoading;
// }

// function changeStatusLoaderValidarTcoo(state, action) {
//   const { isLoading } = action.payload;
//   state.loaderValidarTcco = isLoading;
// }

// function changeStatusLoaderSesion(state, action) {
//   const { isLoading } = action.payload;
//   state.loaderSesion = isLoading;
// }

// function changeStatusLoaderInformar(state, action) {
//   const { isLoading } = action.payload;
//   state.loaderInformar = isLoading;
// }

// function changeStatusObtener(state, action) {
//   const { isLoading } = action.payload;
//   state.loaderObtener = isLoading;
// }


const casoBordes = createAction('casoBordes');


const casosBordesReducer = createSlice({
  name: 'casoBordes',
  initialState,
  reducers: {
    casoBordeEstado
  },
});

export const casoBordeActions = {
  ...casosBordesReducer.actions,
  casoBordes
};

export default casosBordesReducer.reducer;
